import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../../hoc/clientOnly';
import ProductCarousel from './ProductCarousel';
import StoreCarousel from './StoreCarousel';

const Carousel = lazy(() =>
  import(/* webpackChunkName: "Carousel" */ './Carousel')
);

const Loader = props => (
  <Suspense fallback={null}>
    <Carousel {...props} />
  </Suspense>
);

export default clientOnly(Loader);
export { ProductCarousel };
export { StoreCarousel };
